<template>
  <nav id="nav" :class="design">
    <div class="content left-content" v-if="design === 'ecruise'">
      <icon-component iconName="mainLogo" class="logo" />

      <div
        v-if="authData.posId && posDataValue && posDataValue.department"
        class="department-title"
      >
        <span class="department-title--dep">{{
          posDataValue.department.name
        }}</span>
        <span class="department-title--name">{{ posDataValue.name }}</span>
      </div>

      <refresh-btn-component
        @click="refreshSettings"
        class="refresh-btn"
        :text="'refresh'"
        :customStyles="'padding:0; width: 122px; height: 60px; border: 2px solid #3F8EC5; box-shadow: none'"
      ></refresh-btn-component>

      <!-- <base-button text="refresh" classes="def-btn secondary-action-btn uppercase medium border-2 icon left" customStyles="padding:0; width: 122px; height: 60px;" imgSrc="24refresh.svg" @onClick="refreshSettings"/> -->

      <template v-if="businessDay">
        <div v-if="businessDay.active" class="day-status day-status_r">
          <icon-component iconName="bdRolled" />
          <p>IN OPERATION</p>
        </div>
        <div v-else class="day-status day-status_s">
          <icon-component iconName="bdStopped" />
          <p>COMPLETED</p>
        </div>
      </template>

      <!-- <button :class="'def-btn main-action-btn big border-2 medium icon left uppercase ' +
			design"
							@click="changeDepartment()">
				<span>CHANGE DEPARTMENT</span>
			</button> -->
    </div>

    <div class="content left-content" v-if="design === 'margaritaville'">
      <icon-component iconName="mainLogoPalm" style="margin: 20px 0 0 -20px" />
      <icon-component
        iconName="mainLogo"
        class="margaritaville-main-logo"
        style="margin-left: -110px"
      />

      <refresh-btn-component
        @click="refreshSettings"
        class="refresh-btn"
        :text="'refresh'"
        :customStyles="'padding:0; margin-left: 24px; width: 122px; height: 60px; border: 2px solid #3F8EC5; box-shadow: none'"
      ></refresh-btn-component>

      <template v-if="businessDay">
        <div v-if="businessDay.active" class="day-status day-status_r">
          <icon-component iconName="bdRolled" />
          <p>IN OPERATION</p>
        </div>
        <div v-else class="day-status day-status_s">
          <icon-component iconName="bdStopped" />
          <p>COMPLETED</p>
        </div>
      </template>

      <div
        v-if="authData.posId && posDataValue && posDataValue.department"
        class="margaritaville-department-name"
      >
        {{ posDataValue.department.name }}
      </div>
    </div>

    <div class="content center-content">
      <div v-if="activeTax" class="active-tax-name">
        <span class="active-tax-name__label">Active tax:</span>
        <span class="active-tax-name__value">{{ activeTax.name }}</span>
        <span class="active-tax-name__percent">{{ activeTax.percentage }}%</span>
      </div>
    </div>

    <div class="content right-content">
      <div v-if="authData.status.loggedIn" class="pos-title">
        {{ authData.user.user.first_name }}
        {{ authData.user.user.last_name }}
        <span v-if="authData.user.role === 'waiter assist'">(assistant)</span>
      </div>

      <base-button
        text="log out"
        classes="def-btn main-action-btn uppercase medium border-2 icon left"
        customStyles="padding:0; width: 156px; height: 60px;"
        imgSrc="logout"
        @onClick="logout"
      />
    </div>
    <!--:has-keyboard="true" :show-keyboard="inFocus.length > 0" @clickOnKey="click"-->
    <!-- <modal-component ref="modal" :has-keyboard="true" @clickOnKey="clickOnKey" @onModalClose="onModalClose">
			<terminal-setup-root-component ref="terminal-setup-root-component" :isAuth="true" @dep-changed="depChanged()"
			></terminal-setup-root-component>
		</modal-component> -->
  </nav>
</template>

<script>
import { authService } from "@/_api/auth.api";
import store from "@/store";
import ModalComponent from "@/components/_shared/Modal.vue";
import TerminalSetupRootComponent from "@/views/auth/TerminalSetup.vue";
import BaseButton from "@/components/_shared/Button.vue";
import getPosHelper from "@/_helpers/get-pos-helper";
import { settingsService } from "@/_api/settings.api";
import RefreshBtnComponent from "@/components/_shared/RefreshButton";
import iconComponent from "@/components/_shared/Icon.vue";
import { init as initSettings } from "@/_helpers/settings";
import { taxesService } from "@/_api/taxes.api";

export default {
  name: "HeaderComponent",
  props: {},
  components: {
    TerminalSetupRootComponent,
    ModalComponent,
    BaseButton,
    RefreshBtnComponent,
    iconComponent,
  },
  data() {
    return {
      activeTax: null,
      activeTaxPollId: null,
      isActiveTaxLoading: false,
      // posData: null
    };
  },
  computed: {
    design() {
      return this.$store.state.UI;
    },
    authData() {
      this.posData = this.$store.state.auth.posData;
      return this.$store.state.auth;
    },
    posDataValue() {
      return this.$store.state.auth.posData;
    },
    businessDay() {
      return this.$store.state.settings.businessDay;
    },
  },
  created() {},
  mounted() {
    if (this.authData.status.loggedIn) {
      settingsService
        .getLastBusinessDay()
        .then((res) => {
          store.dispatch("setBusinessDay", res);
        })
        .catch((err) => {
          console.error(err);
        });

      this.fetchActiveTax();
      this.startActiveTaxPolling();
      document.addEventListener("visibilitychange", this.onVisibilityChange);
    }
  },
  beforeUnmount() {
    this.stopActiveTaxPolling();
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
  },
  methods: {
    refreshSettings() {
      authService
        .getPos({
          id: this.authData.posId,
        })
        .then((res) => {
          if (res) {
            this.emmiter.emit("refreshOrders");
            store.dispatch("savePosData", res);
            this.getSettings();
            this.getBusinessDayStatus();
            this.fetchActiveTax();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    startActiveTaxPolling() {
      this.stopActiveTaxPolling();

      this.fetchActiveTax();

      this.activeTaxPollId = window.setInterval(() => {
        if (this.isActiveTaxLoading) return;
        this.fetchActiveTax();
      }, 5000);
    },
    stopActiveTaxPolling() {
      if (this.activeTaxPollId) {
        clearInterval(this.activeTaxPollId);
        this.activeTaxPollId = null;
      }
    },
    onVisibilityChange() {
      if (document.visibilityState === "visible") {
        this.fetchActiveTax();
      }
    },
    getPos() {
      getPosHelper(this.authData.posId);
    },
    getSettings() {
      settingsService
        .getSettings()
        .then((res) => {
          initSettings(this.$store, res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getBusinessDayStatus() {
      settingsService
        .getLastBusinessDay()
        .then((res) => {
          store.dispatch("setBusinessDay", res);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async fetchActiveTax() {
      this.isActiveTaxLoading = true;

      try {
        const next = await taxesService.getActiveTax();

        const prevId = this.activeTax?.id ?? null;
        const nextId = next?.id ?? null;

        if (prevId !== nextId) {
          this.activeTax = next;
          return;
        }

        const prevSig = this.activeTax
          ? `${this.activeTax.name}|${this.activeTax.percentage}|${this.activeTax.active}`
          : "";
        const nextSig = next ? `${next.name}|${next.percentage}|${next.active}` : "";

        if (prevSig !== nextSig) {
          this.activeTax = next;
        }
      } catch (err) {
        const status = err?.response?.status;

        if (status === 404) {
          this.activeTax = null;
          return;
        }

        if (status === 401 || status === 403) {
          this.activeTax = null;
          this.stopActiveTaxPolling();
          return;
        }

        console.error(err);
        this.activeTax = null;
      } finally {
        this.isActiveTaxLoading = false;
      }
    },
    logout() {
      this.$store.dispatch("logoutUser").then(() => {
        this.$router.replace({ path: "/auth/login" });
      });
    },
    changeDepartment() {
      this.$refs.modal.open();
    },
    // depChanged() {
    // 	this.getPos();
    // 	// this.$refs.modal.close();
    // },
    onModalClose() {},
    clickOnKey(e) {
      if (e === undefined) {
        this.$refs["terminal-setup-root-component"].clear();
      } else {
        this.$refs["terminal-setup-root-component"].clickOnKey(e);
      }
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
#nav {
  display: flex;
  width: 100%;
  height: 54px;
  align-items: stretch;
  padding: 15px 18px;
  gap: 24px;

  .content {
    display: flex;
    align-items: center;

    .logo {
      width: 60px;
      height: 54px;
      margin-right: 24px;
    }

    .department-title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      margin-right: 24px;

      &--dep {
        color: #3f8ec5;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        text-transform: uppercase;
      }

      &--name {
        color: #3f8ec5;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        text-transform: uppercase;
      }
    }

    .day-status {
      display: flex;
      align-items: center;
      margin-left: 26px;
      gap: 6px;
      text-transform: uppercase;

      img {
        width: 30px;
      }

      p {
        margin: 0;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 21px;
      }

      &_r {
        p {
          color: #82b941;
        }
      }

      &_s {
        p {
          color: #eb262b;
        }
      }
    }

    .pos-title {
      margin-right: 24px;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 21px;
      text-align: right;
      text-transform: uppercase;
    }

    span {
      margin-left: 5px;
    }
  }

  .left-content,
  .right-content {
    flex: 0 0 auto;
  }

  .center-content {
    flex: 1 1 auto;
    min-width: 0;
    justify-content: center;
    align-items: stretch;
    padding: 0 12px;
  }
}

@media (max-width: 1200px) {
  #nav {
    height: 50px;

    .content {
      .logo {
        height: 50px;
      }

      .def-btn {
        padding: 5px 25px !important;
      }
    }
  }
}

@media (max-width: 850px) {
}

.margaritaville-main-logo {
  max-width: 357px;
  max-height: 52px;
}

.margaritaville-department-name {
  margin-left: 24px;
  color: #ffffff;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-transform: uppercase;
}

.active-tax-name {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0 10px;
  gap: 8px;
  overflow: hidden;
  color: #ffffff;
  background-color: #eb262b;
  border-radius: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  text-transform: uppercase;
  text-overflow: ellipsis;
  white-space: nowrap;

  &__label,
  &__value,
  &__percent {
    flex: 0 1 auto;
    min-width: 0;
  }

  &__value {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
